<template>
  <v-container fluid class="px-0" v-m2-span>
		<div>
			<div class="my-4 mx-2">
				<div class="d-flex align-center">
					<div class="flex-grow-1 mr-2" style="border-bottom: 1px solid #ccc;"></div>
					<span class="mx-2 font-weight-bold body-1">Tabla Costo Total Proyecto</span>
					<div class="flex-grow-1 ml-2" style="border-bottom: 1px solid #ccc;"></div>
				</div>
				<div class="d-flex justify-space-between align-center">
					<div class="flex-1"></div>
					<div class="d-flex flex-1 justify-center align-center">
						<div v-if="!fromModal">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										depressed
										color="grey"
										small
										icon
										class="mr-1"
										v-show="showShowMainTable"
										v-bind="attrs"
										v-on="on"
										@click.stop="$store.commit('costbreakdown/setCostBreakdownMainTableModal', true)"
									>
										<v-icon>mdi-eye</v-icon>
									</v-btn>
								</template>
								<span>Visualización Rápida Tabla General</span>
							</v-tooltip>
						</div>
						<div v-if="!fromModal">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										depressed
										color="grey"
										small
										icon
										class="mr-1"
										v-show="showShowMainTable"
										v-bind="attrs"
										v-on="on"
										@click.stop="openCostBreakdownSummary({ showPaymentConfig: true })"
									>
										<v-icon>mdi-table-eye</v-icon>
									</v-btn>
								</template>
								<span>Visualización Rápida Tabla Programación Pagos</span>
							</v-tooltip>
						</div>
						<v-menu
							v-model="colorPickerVisible"
							:close-on-content-click="false"
							offset-y
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									depressed
									color="grey"
									small
									v-bind="attrs"
									v-on="on"
								>
									<v-icon>mdi-palette</v-icon>
								</v-btn>
							</template>
							<v-card>
								<div>
									<div class="pa-2">
										<p class="mb-0 caption font-weight-bold">Selecciona Un Color a Editar</p>
										<p class="mb-1" style="font-size: 10px">Selecciona el color de la tabla que quieres modificar</p>
										<div class="d-flex align-center">
											<v-tooltip bottom
														v-for="(colorVar, key) in colorVars"
														:key="key">
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														depressed
														color="white"
														small
														icon
														v-bind="attrs"
														v-on="on"
														:style="{
															border: activeColorKey === colorVar.value ? '2px solid #000' : '2px solid #cecece',
															marginRight: '5px',
															boxShadow: activeColorKey === colorVar.value ? '0 0 5px rgba(0,0,0,0.3)' : 'none'
														}"
														@click="openColorPicker(colorVar.value)"
													>
														<v-icon :color="colors[colorVar.value]">mdi-circle</v-icon>
													</v-btn>
												</template>
												<span>{{colorVar.text}}</span>
											</v-tooltip>
										</div>
									</div>
									<v-color-picker
										v-model="currentColor"
										dot-size="25"
										hide-sliders
										mode="rgba"
										dense
										show-swatches
										swatches-max-height="100"
									/>
								</div>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn text @click="colorPickerVisible = false">Cerrar</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>
					</div>
					<div class="flex-1 d-flex justify-end align-center">
						<v-tooltip bottom v-if="costsPayments.length > 0">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									depressed
									color="black"
									outlined
									small
									@click="startSendTableCostToClient"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon small>mdi-send</v-icon>
									<p class="mb-0 ml-2">Enviar a Cliente</p>
								</v-btn>
							</template>
							<span>Enviar esta información al cliente</span>
						</v-tooltip>
					</div>
				</div>
			</div>
			<v-simple-table style="zoom: 90%" class="custom-table-cost caption">
				<template v-slot:default>
					<thead>
						<tr class="header-rows-custom" :style="{ backgroundColor: paymentStatusTableColor, color: calcFontColor(paymentStatusTableColor) }">
							<td style="vertical-align: middle;" colspan="11" class="text-left">
								<div class="d-flex align-center justify-space-between">
									<p class="mb-0 font-weight-bold">Costo Proyecto</p>
								</div>
							</td>
						</tr>
						<tr class="header-rows-custom" :style="{ backgroundColor: paymentStatusTableColor, color: calcFontColor(paymentStatusTableColor) }">
							<td style="vertical-align: middle;min-width: 160px;" :width="colWidths[0]" rowspan="2"><p class="text-left mb-0 caption font-weight-bold" >Estado Pago</p></td>
							<td style="vertical-align: middle;min-width: 160px;" :width="colWidths[1]" rowspan="2"><p class="text-right mb-0 caption font-weight-bold" >Contrato Inicial</p></td>
							<td style="vertical-align: middle;min-width: 160px;" :width="colWidths[2]" rowspan="2"><p class="text-center mb-0 caption font-weight-bold" >Fecha para Pago</p></td>
							<td style="vertical-align: middle;min-width: 160px;" :width="colWidths[3]" rowspan="2"><p class="text-center mb-0 caption font-weight-bold" >Aumento / Descuento <br/>Elaboración Contrato</p></td>
							<td style="vertical-align: middle;min-width: 160px;" :width="colWidths[4]" :colspan="showFullToPayInfo ? 3:1">
								<div class="d-flex align-center justify-center">
									<p class="text-center mb-0 caption font-weight-bold" >Monto a Pagar</p>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												dark
												x-small
												:color="calcFontColor(paymentStatusTableColor)"
												@click="showFullToPayInfo = !showFullToPayInfo"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon small dark class="ml-2">{{showFullToPayInfo ? 'mdi-table-eye-off' : 'mdi-table-eye' }}</v-icon>
											</v-btn>
										</template>
										<span>Ver Detalles</span>
									</v-tooltip>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 160px;" :width="colWidths[5]" rowspan="2"><p class="text-right mb-0 caption font-weight-bold" >Pagos Cliente (Total)</p></td>
							<td style="vertical-align: middle;min-width: 160px;" :width="colWidths[6]" rowspan="2"><p class="text-right mb-0 caption font-weight-bold" >Saldo Cliente</p></td>
							<td style="vertical-align: middle;min-width: 160px;" :width="colWidths[7]" rowspan="2"><p class="text-right mb-0 caption font-weight-bold" >Observación</p></td>
							<td style="vertical-align: middle;" rowspan="2"></td>
						</tr>
						<tr class="header-rows-custom" :style="{ backgroundColor: paymentStatusTableColor, color: calcFontColor(paymentStatusTableColor) }">
							<td style="vertical-align: middle;min-width: 160px;" class="text-right" v-if="showFullToPayInfo">Neto</td>
							<td style="vertical-align: middle;min-width: 160px;" class="text-right" v-if="showFullToPayInfo">{{ costsTable.tax?.name }} ({{ costsTable.tax?.value }}%)</td>
							<td style="vertical-align: middle;min-width: 160px;" class="text-right">Total</td>
						</tr>
					</thead>
					
					<tbody>
						<tr v-for="(costsPayment, index) in costsTable.payments" :key="'paym.status-'+costsPayment.id">
							<td style="vertical-align: middle;min-width: 160px;">
								<p class="text-left mb-0 caption font-weight-bold" >EP{{ index+1 }}</p>
								<v-divider class="my-1"></v-divider>
								<p class="text-left mb-0" style="font-size: 10px;"><b>{{ costsPayment.stage.name }}:</b> {{ costsPayment.stage.description }}</p>
							</td>
							<td style="vertical-align: middle;min-width: 160px;">
								<p class="text-right mb-0 caption font-weight-bold body-1" >{{getSinglePaymentTotalsWithTax(costsPayment, costsTable).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 caption font-weight-bold body-1" >${{getSinglePaymentTotalsWithTax(costsPayment, costsTable).total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 160px;">
								<DateSelector :costsPayment="costsPayment" :onDateChange="handleDateChange"/>
								<div v-if="costsPayment.pay_date">
									<p class="mb-0 caption text-center" v-if="getSetUfValue(costsPayment)?.status">{{ getSetUfValue(costsPayment).text }}</p>
									<p class="mb-0 caption text-center error--text" v-else>UF aún no informada por sistema público</p>
								</div>
							</td>
							<!-- Anexos -->
							<td style="vertical-align: middle;min-width: 160px;">
								<p class="text-right mb-0 caption font-weight-bold body-1" >{{getTotalSinglePaymentTotalsWithTax(costsPayment).total_cost_uf_taxed - getSinglePaymentTotalsWithTax(costsPayment, costsTable).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 caption font-weight-bold body-1" >${{getTotalSinglePaymentTotalsWithTax(costsPayment).total_cost_clp_taxed - getSinglePaymentTotalsWithTax(costsPayment, costsTable).total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
							<!-- Monto a Pagar -->
							<td style="vertical-align: middle;min-width: 160px;" v-if="showFullToPayInfo">
								<p class="text-right mb-0 caption font-weight-bold body-1">{{getTotalSinglePaymentTotalsWithTax(costsPayment).total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 caption font-weight-bold body-1">${{getTotalSinglePaymentTotalsWithTax(costsPayment).total_cost_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 160px;" v-if="showFullToPayInfo">
								<p class="text-right mb-0 caption font-weight-bold body-1">{{getTotalSinglePaymentTotalsWithTax(costsPayment).tax_value_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 caption font-weight-bold body-1">${{getTotalSinglePaymentTotalsWithTax(costsPayment).tax_value_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 160px;">
								<div class="d-flex align-start justify-space-between">
									<v-menu bottom offset-y open-on-hover content-class="custom-tooltip-payment-status-details">
										<template v-slot:activator="{ on, attrs }">
											<v-icon
												class="mt-1"
												small
												v-bind="attrs"
												v-on="on">mdi-format-list-checkbox</v-icon>
										</template>
										<div style="color: black;max-width: 320px;">
											<div class="d-flex align-start justify-space-between">
												<p class="mb-1 font-weight-bold caption">Detalle: EP{{ index+1 }} - <b>{{ costsPayment.stage.name }}</b></p>
												<div>
													<p class="text-right mb-0" style="font-size: 8px;">Total EP</p>
													<p class="text-right mb-0 font-weight-bold" style="font-size: 10px;">{{getTotalSinglePaymentTotalsWithTax(costsPayment).total_cost_uf_taxed | toThousandFilter(2)}} UF | ${{getTotalSinglePaymentTotalsWithTax(costsPayment).total_cost_clp_taxed | toThousandFilter}} CLP</p>
												</div>
											</div>
											<v-divider class="my-1"></v-divider>
											<div v-if="costsPayment.payments.length === 0">
												<p class="mb-0 caption">No existen pagos configurados para este Estado de Pago.</p>
											</div>
											<div v-else>
												<p class="mb-0 caption">En este Estado de Pago se incluye:</p>
												<div class="py-2">
													<div v-for="(payment, index) in getFilteredPaymentsForStage(costsPayment)" :key="'payment_' + index">
														<div class="d-flex align-center justify-space-between pa-2" :style="{ 'gap': '10px', 'background-color': '#ccc', 'border-radius': payment.subpayments && payment.subpayments.length > 0 ? '5px 5px 0 0' : '5px' }">
															<div style="max-width: 200px;">
																<v-chip
																	:color="getCostsPaymentDetails(payment).isAddendum ? '#FF120B' : 'green'"
																	text-color="white"
																	label
																	x-small
																	style="width: 100px;"
																	class="mb-1 mr-2 px-2 d-flex justify-center">
																	<p class="mb-0">{{ getCostsPaymentDetails(payment).isAddendum ? 'Anexo / Adicional' : 'Tabla General' }}</p>
																</v-chip>
																<p v-m2-span class="mb-0 font-weight-bold text--disabled" style="font-size: 10px; line-height: 10px;" v-if="getCostsPaymentDetails(payment).projectTypeSubtitle">{{ getCostsPaymentDetails(payment).projectTypeSubtitle }}</p>
																<p class="mb-0 caption font-weight-bold" v-html="getCostsPaymentDetails(payment).title"></p>
															</div>
															<div>
																<p class="text-right mb-0 caption font-weight-bold body-1" >{{getCostsPaymentDetails(payment).total?.total_cost_uf_taxed * payment.amount/100 | toThousandFilter(2)}} UF</p>
																<p class="text-right mb-0 caption font-weight-bold body-1" >${{getCostsPaymentDetails(payment).total?.total_cost_clp_taxed * payment.amount/100 | toThousandFilter}} CLP</p>
															</div>
														</div>
														<div v-if="payment.subpayments && payment.subpayments.length > 0" class="payments-subdetails-box">
															<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px; line-height: 10px;">Detalle Cuotas Configuradas</p>
															<div v-for="(subpayment, subIndex) in payment.subpayments" :key="'subpayment_' + subIndex">
																<div class="d-flex align-center justify-end px-1" style="gap: 10px;">
																	<p class="mb-0 font-weight-bold text-right" style="font-size: 10px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; word-break: break-word;">{{ subpayment.title }}</p>
																	<div style="width: 90px;">
																		<p class="text-right mb-0" style="font-size: 10px;">{{ getCostsPaymentDetails(payment).total?.total_cost_uf_taxed * subpayment.amount/100 | toThousandFilter(2) }} UF</p>
																		<p class="text-right mb-0" style="font-size: 10px;">${{ getCostsPaymentDetails(payment).total?.total_cost_clp_taxed * subpayment.amount/100 | toThousandFilter }} CLP</p>
																	</div>
																</div>
																<v-divider class="my-1" v-if="subIndex < payment.subpayments.length -1"></v-divider>
															</div>
														</div>
														<v-divider class="my-1" v-if="index < costsPayment.payments.length -1"></v-divider>
													</div>
												</div>
											</div>
										</div>
									</v-menu>
									<div>
										<p class="text-right mb-0 caption font-weight-bold body-1" >{{getTotalSinglePaymentTotalsWithTax(costsPayment).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 caption font-weight-bold body-1" >${{getTotalSinglePaymentTotalsWithTax(costsPayment).total_cost_clp_taxed | toThousandFilter}} CLP</p>
									</div>
								</div>
							</td>
							<!-- Pagos Cliente -->
							<td style="vertical-align: middle;min-width: 160px;position: relative;">
								<p class="text-right mb-0 caption font-weight-bold body-1" >{{totalPaid(costsPayment).total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 caption font-weight-bold body-1" >${{totalPaid(costsPayment).total_cost_clp | toThousandFilter}} CLP</p>
								<div style="position: absolute;top: 0; left: 0;">
									<PaymentHistory :payments="costsPayment.payment_order" />
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 160px;">
								<div>
									<p class="text-right mb-0 caption font-weight-bold body-1"
										:class="{
											'error--text': getDifference(costsPayment).total_cost_uf > 0,
											'success--text': getDifference(costsPayment).total_cost_uf < 0
										}">{{getDifference(costsPayment).total_cost_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold body-1"
										:class="{
											'error--text': getDifference(costsPayment).total_cost_clp > 0,
											'success--text': getDifference(costsPayment).total_cost_clp < 0
										}">${{getDifference(costsPayment).total_cost_clp | toThousandFilter}} CLP</p>
								</div>
								<!-- <div class="text-end" v-else>--</div> -->
							</td>
							<td style="vertical-align: middle;min-width: 160px;"><p class="text-right mb-0 caption font-weight-bold" >--</p></td>
							<td style="vertical-align: middle;">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											x-small
											color="rgba(0, 0, 0, 0.87)"
											@click="openManualPaymentModal(costsPayment)"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon small dark>mdi-credit-card-outline</v-icon>
										</v-btn>
									</template>
									<span>Agregar Pago Manual</span>
								</v-tooltip>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											x-small
											color="rgba(0, 0, 0, 0.87)"
											@click="sendPaymentRequest(costsPayment)"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon small dark>mdi-send-outline</v-icon>
										</v-btn>
									</template>
									<span>Enviar Solicitud de Pago por Correo</span>
								</v-tooltip>
							</td>
						</tr>
						<tr class="header-rows-custom" style="background-color: #cecece; color: rgba(0, 0, 0, 0.87);">
							<td style="vertical-align: middle;min-width: 160px;">
								<p class="mb-0 caption font-weight-bold">Total Estados de Pago</p>
							</td>
							<td style="vertical-align: middle;min-width: 160px;" :style="{ color: statusComprobation ? 'green' : 'red' }">
								<div class="d-flex align-start justify-space-between">
									<v-tooltip bottom content-class="custom-tooltip-payment-status">
										<template v-slot:activator="{ on, attrs }">
											<v-icon
												class="mt-1"
												small
												:color="statusComprobation ? 'green' : 'red'"
												v-bind="attrs"
												v-on="on">mdi-alert-box</v-icon>
										</template>
										<div style="color: black;" v-if="statusComprobation">
											<p class="mb-1 font-weight-bold">Estados de Pago</p>
											<p class="mb-0 caption">La configuración de los estados de pagos está completa.</p>
										</div>
										<div style="color: black;" v-else>
											<p class="mb-1 font-weight-bold">Estados de Pago Incompletos</p>
											<p class="mb-0 caption">Los estados de pago no se han configurado al 100%.</p>
											<p class="mb-0 caption">Completa la configuración en la sección "Tabla Resumen / Programación Pagos".</p>
										</div>
									</v-tooltip>
									<div>
										<p class="text-right mb-0 font-weight-bold body-1" >{{getAllPaymentsTotalsWithTax(costsPayments, costsTable).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 font-weight-bold body-1" >${{getAllPaymentsTotalsWithTax(costsPayments, costsTable).total_cost_clp_taxed | toThousandFilter}} CLP</p>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 160px;"><p class="text-center mb-0 caption font-weight-bold" ></p></td>
							<!-- Anexos -->
							<td style="vertical-align: middle;min-width: 160px;" :style="{ color: statusComprobation ? 'green' : 'red' }">
								<div class="d-flex align-start justify-space-between">
									<v-tooltip bottom content-class="custom-tooltip-payment-status">
										<template v-slot:activator="{ on, attrs }">
											<v-icon
												class="mt-1"
												small
												:color="statusComprobation ? 'green' : 'red'"
												v-bind="attrs"
												v-on="on">mdi-alert-box</v-icon>
										</template>
										<div style="color: black;" v-if="statusComprobation">
											<p class="mb-1 font-weight-bold">Estados de Pago</p>
											<p class="mb-0 caption">La configuración de los estados de pagos está completa.</p>
										</div>
										<div style="color: black;" v-else>
											<p class="mb-1 font-weight-bold">Estados de Pago Incompletos</p>
											<p class="mb-0 caption">Los estados de pago no se han configurado al 100%.</p>
											<p class="mb-0 caption">Completa la configuración en la sección "Tabla Resumen / Programación Pagos".</p>
										</div>
									</v-tooltip>
									<div>
										<p class="text-right mb-0 font-weight-bold body-1" >{{totalAddendumCostPayments.total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 font-weight-bold body-1" >${{totalAddendumCostPayments.total_cost_clp_taxed | toThousandFilter}} CLP</p>
									</div>
								</div>
							</td>
							<!-- Monto a Pagar -->
							<td style="vertical-align: middle;min-width: 160px;" v-if="showFullToPayInfo" :style="{ color: statusComprobation ? 'green' : 'red' }">
								<div class="d-flex align-start justify-space-between">
									<v-tooltip bottom content-class="custom-tooltip-payment-status">
										<template v-slot:activator="{ on, attrs }">
											<v-icon
												class="mt-1"
												small
												:color="statusComprobation ? 'green' : 'red'"
												v-bind="attrs"
												v-on="on">mdi-alert-box</v-icon>
										</template>
										<div style="color: black;" v-if="statusComprobation">
											<p class="mb-1 font-weight-bold">Estados de Pago</p>
											<p class="mb-0 caption">La configuración de los estados de pagos está completa.</p>
										</div>
										<div style="color: black;" v-else>
											<p class="mb-1 font-weight-bold">Estados de Pago Incompletos</p>
											<p class="mb-0 caption">Los estados de pago no se han configurado al 100%.</p>
											<p class="mb-0 caption">Completa la configuración en la sección "Tabla Resumen / Programación Pagos".</p>
										</div>
									</v-tooltip>
									<div>
										<p class="text-right mb-0 font-weight-bold body-1" >{{totalProjectCostSummaryPayments.total_cost_uf | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 font-weight-bold body-1" >${{totalProjectCostSummaryPayments.total_cost_clp | toThousandFilter}} CLP</p>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 160px;" v-if="showFullToPayInfo" :style="{ color: statusComprobation ? 'green' : 'red' }">
								<div class="d-flex align-start justify-space-between">
									<v-tooltip bottom content-class="custom-tooltip-payment-status">
										<template v-slot:activator="{ on, attrs }">
											<v-icon
												class="mt-1"
												small
												:color="statusComprobation ? 'green' : 'red'"
												v-bind="attrs"
												v-on="on">mdi-alert-box</v-icon>
										</template>
										<div style="color: black;" v-if="statusComprobation">
											<p class="mb-1 font-weight-bold">Estados de Pago</p>
											<p class="mb-0 caption">La configuración de los estados de pagos está completa.</p>
										</div>
										<div style="color: black;" v-else>
											<p class="mb-1 font-weight-bold">Estados de Pago Incompletos</p>
											<p class="mb-0 caption">Los estados de pago no se han configurado al 100%.</p>
											<p class="mb-0 caption">Completa la configuración en la sección "Tabla Resumen / Programación Pagos".</p>
										</div>
									</v-tooltip>
									<div>
										<p class="text-right mb-0 font-weight-bold body-1" >{{totalProjectCostSummaryPayments.tax_value_uf | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 font-weight-bold body-1" >${{totalProjectCostSummaryPayments.tax_value_clp | toThousandFilter}} CLP</p>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 160px;" :style="{ color: statusComprobation ? 'green' : 'red' }">
								<div class="d-flex align-start justify-space-between">
									<v-tooltip bottom content-class="custom-tooltip-payment-status">
										<template v-slot:activator="{ on, attrs }">
											<v-icon
												class="mt-1"
												small
												:color="statusComprobation ? 'green' : 'red'"
												v-bind="attrs"
												v-on="on">mdi-alert-box</v-icon>
										</template>
										<div style="color: black;" v-if="statusComprobation">
											<p class="mb-1 font-weight-bold">Estados de Pago</p>
											<p class="mb-0 caption">La configuración de los estados de pagos está completa.</p>
										</div>
										<div style="color: black;" v-else>
											<p class="mb-1 font-weight-bold">Estados de Pago Incompletos</p>
											<p class="mb-0 caption">Los estados de pago no se han configurado al 100%.</p>
											<p class="mb-0 caption">Completa la configuración en la sección "Tabla Resumen / Programación Pagos".</p>
										</div>
									</v-tooltip>
									<div>
										<p class="text-right mb-0 font-weight-bold body-1" >{{totalProjectCostSummaryPayments.total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 font-weight-bold body-1" >${{totalProjectCostSummaryPayments.total_cost_clp_taxed | toThousandFilter}} CLP</p>
									</div>
								</div>
							</td>
							<!-- Pagos Cliente -->
							<td style="vertical-align: middle;min-width: 160px;">
								<p class="text-right mb-0 font-weight-bold body-1" >{{totalPaidTotals.total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{totalPaidTotals.total_cost_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 160px;">
								<p class="text-right mb-0 font-weight-bold body-1" >{{totalDifference.total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{totalDifference.total_cost_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 160px;"></td>
							<td style="vertical-align: middle;"></td>
						</tr>
						<tr class="header-rows-custom" style="border-top: 15px solid white;" :style="{ backgroundColor: secondFooterPaymentStatusColor, color: calcFontColor(secondFooterPaymentStatusColor) }">
							<td style="vertical-align: middle;min-width: 160px;">
								<p class="mb-0 caption font-weight-bold">Total Contrato</p>
								<p class="mb-0" style="font-size: 10px;">(Comprobación)</p>
							</td>
							<td style="vertical-align: middle;min-width: 160px;">
								<p class="text-right mb-0 font-weight-bold body-1" >{{totalMainProjectCost.total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{totalMainProjectCost.total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 160px;"><p class="text-center mb-0 caption font-weight-bold" ></p></td>
							<!-- Anexos -->
							<td style="vertical-align: middle;min-width: 160px;">
								<!-- <p class="text-right mb-0 font-weight-bold body-1" >{{getPaymentAdjust(costsPayments).adjustment_uf | toThousandFilter(2)}} UF</p> -->
								<p class="text-right mb-0 font-weight-bold body-1" >{{totalAddendumCost.total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{totalAddendumCost.total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
							<!-- Monto a Pagar -->
							<td style="vertical-align: middle;min-width: 160px;" v-if="showFullToPayInfo">
								<p class="text-right mb-0 font-weight-bold body-1">{{totalProjectCostSummary.total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1">${{totalProjectCostSummary.total_cost_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 160px;" v-if="showFullToPayInfo">
								<p class="text-right mb-0 font-weight-bold body-1">{{totalProjectCostSummary.tax_value_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1">${{totalProjectCostSummary.tax_value_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 160px;">
								<p class="text-right mb-0 font-weight-bold body-1" >{{totalProjectCostSummary.total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{totalProjectCostSummary.total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
							<!-- <td style="vertical-align: middle;min-width: 160px;">
								<p class="text-right mb-0 font-weight-bold body-1" >{{getAllPaymentsToPay(costsPayments, costsTable).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{getAllPaymentsToPay(costsPayments, costsTable).total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td> -->
							<td style="vertical-align: middle;min-width: 160px;">
								<!-- <p class="text-right mb-0 font-weight-bold body-1" >{{totalPaidTotals.total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{totalPaidTotals.total_cost_clp | toThousandFilter}} CLP</p> -->
							</td>
							<td style="vertical-align: middle;min-width: 160px;">
								<!-- <p class="text-right mb-0 font-weight-bold body-1" >{{totalDifference.total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{totalDifference.total_cost_clp | toThousandFilter}} CLP</p> -->
							</td>
							<td style="vertical-align: middle;min-width: 160px;"></td>
							<td style="vertical-align: middle;"></td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</div>
	</v-container>
</template>

<script>
import DateSelector from '@/components/Views/Projects/CostSummary/DateSelector';
import PaymentHistory from '@/components/Views/Projects/CostSummary/PaymentHistory';
import { createPaymentOrder, sendPaymentRequest } from '@/helpers/api/general';
import { getParentItemTotalValueMultiWithTax, getParentItemTotalValueWithTax, getSinglePaymentTotalsWithTax, getPaymentToPay, getAllPaymentsTotalsWithTax, getPaymentAdjust, getAllPaymentsToPay, findItemInCostsTable } from '@/helpers/tablecostHelpers.js'

export default {
	name: 'CostPaymentStatusTable',
	components: {DateSelector, PaymentHistory},
	props: {
		costsTable: {
			type: Object,
			required: true
		},
		project: {
			type: Object,
			required: true
		},
		ufValue: {
			type: Number,
			required: true
		},
		currency: {
			type: String,
			required: true
		},
		showShowMainTable: {
			type: Boolean,
			default: true
		},
		project_tables: {
			type: Array,
			default: () => []
		},
		fromModal: {
			type: Boolean,
			default: false
		},
	},
  data() {
    return {
			getSinglePaymentTotalsWithTax,
			getAllPaymentsTotalsWithTax,
			getPaymentToPay,
			getAllPaymentsToPay,
			getPaymentAdjust,
			findItemInCostsTable,
			showFullToPayInfo: false,
			colWidths: ['20%','10%','10%','10%','10%','10%','10%','10%','10%'],
      colorVars: [
        { value: 'paymentStatusTableColor', text: 'Título / Cabecera Tabla Estado de Pago' },
				// { value: 'footerPaymentStatusColor', text: 'Total Estados de Pago' },
				{ value: 'secondFooterPaymentStatusColor', text: 'Total Contrato (Comprobación)' }
      ],
      colorPickerVisible: false,
      activeColorKey: 'paymentStatusTableColor',
    };
  },
	computed: {
		summaryInfo(){
			let summary = {
				reception: null,
				surfaces: [],
				projects: [],
				stages: [],
				specialties: [],
				tax: this.costsTable.tax,
				mainProjects: (this.costsTable.reception || (Array.isArray(this.costsTable.surfaces?.items) && this.costsTable.surfaces.items.length > 0)) ? [{ 
					...{
						reception: this.costsTable.reception,
						surfaces: this.costsTable.surfaces
					},
					project_table: this.costsTable
				}] : []
			};
			
			// Agregar elementos del costsTable principal
			if (this.costsTable.reception) {
				summary.reception = { ...this.costsTable.reception, project_table: this.costsTable };
			}
			if (Array.isArray(this.costsTable.surfaces?.items)) {
				summary.surfaces.push(...this.costsTable.surfaces.items.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.projects)) {
				summary.projects.push(...this.costsTable.projects.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.stages)) {
				summary.stages.push(...this.costsTable.stages.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.specialties)) {
				summary.specialties.push(...this.costsTable.specialties.map(item => ({ ...item, project_table: this.costsTable })));
			}
			
			// Agregar elementos de las tablas adicionales
			this.project_tables.forEach(project_table => {
				if (project_table.reception) {
					summary.reception = { ...project_table.reception, project_table };
				}
				if (Array.isArray(project_table.surfaces?.items)) {
					summary.surfaces.push(...project_table.surfaces.items.map(item => ({ ...item, project_table })));
				}
				if (Array.isArray(project_table.projects)) {
					summary.projects.push(...project_table.projects.map(item => ({ ...item, project_table })));
				}
				if (Array.isArray(project_table.stages)) {
					summary.stages.push(...project_table.stages.map(item => ({ ...item, project_table })));
				}
				if (Array.isArray(project_table.specialties)) {
					summary.specialties.push(...project_table.specialties.map(item => ({ ...item, project_table })));
				}
				if (project_table.reception || (Array.isArray(project_table.surfaces?.items) && project_table.surfaces.items.length > 0)) {
					summary.mainProjects.push({ 
						...{
							reception: project_table.reception,
							surfaces: project_table.surfaces
						},
						project_table: project_table
					});
				}
			});
			return summary;
		},
		totalMainProjectCost() {
			let total = {
				total_cost_uf: 0,
				tax_value_uf: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp: 0,
				tax_value_clp: 0,
				total_cost_clp_taxed: 0
			};
			const costsTable = this.costsTable;
			const values = getParentItemTotalValueMultiWithTax([costsTable, costsTable.surfaces, costsTable.stages, costsTable.specialties, costsTable.reception], costsTable.tax, costsTable.uf_value?.uf_value);
			total.total_cost_uf += values.total_cost_uf || 0;
			total.tax_value_uf += values.tax_value_uf || 0;
			total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
			total.total_cost_clp += values.total_cost_clp || 0;
			total.tax_value_clp += values.tax_value_clp || 0;
			total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;

			return total;
		},
		totalAddendumCost() {
			let total = {
				total_cost_uf: 0,
				tax_value_uf: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp: 0,
				tax_value_clp: 0,
				total_cost_clp_taxed: 0
			};

			this.project_tables.forEach(costsTable => {
				const values = getParentItemTotalValueMultiWithTax([costsTable, costsTable.surfaces, costsTable.stages, costsTable.specialties, costsTable.reception], costsTable.tax, costsTable.uf_value?.uf_value);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			return total;
		},
		totalAddendumCostPayments() {
			let total = {
				total_cost_uf: 0,
				tax_value_uf: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp: 0,
				tax_value_clp: 0,
				total_cost_clp_taxed: 0
			};

			this.project_tables.forEach(costsTable => {
				const values = getAllPaymentsTotalsWithTax(this.costsPayments, costsTable)
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			return total;
		},
		totalProjectCostSummary() {
			let total = {
				total_cost_uf: 0,
				tax_value_uf: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp: 0,
				tax_value_clp: 0,
				total_cost_clp_taxed: 0
			};

			const costsTables = [this.costsTable, ...this.project_tables];

			costsTables.forEach(costsTable => {
				const values = getParentItemTotalValueMultiWithTax([costsTable, costsTable.surfaces, costsTable.stages, costsTable.specialties, costsTable.reception], costsTable.tax, costsTable.uf_value?.uf_value);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			return total;
		},
		totalProjectCostSummaryPayments() {
			let total = {
				total_cost_uf: 0,
				tax_value_uf: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp: 0,
				tax_value_clp: 0,
				total_cost_clp_taxed: 0
			};

			const costsTables = [this.costsTable, ...this.project_tables];

			costsTables.forEach(costsTable => {
				const values = getAllPaymentsTotalsWithTax(this.costsPayments, costsTable)
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			return total;
		},
		currentColor: {
			get() {
				return this.colors[this.activeColorKey]
			},
			set(value) {
				this.$store.commit('costbreakdown/setCostTableColorMap', {
					[this.activeColorKey]: value
				});
			}
		},
		totalPaidTotals(){
			let totals = {
				total_cost_uf: 0,
				total_cost_clp: 0,
			}
			this.costsPayments.forEach(costsPayment => {
				const totalPaid = this.totalPaid(costsPayment)
				totals.total_cost_uf += totalPaid.total_cost_uf;
				totals.total_cost_clp += totalPaid.total_cost_clp;
			});
			return totals
		},
		totalDifference(){
			let totals = {
				total_cost_uf: 0,
				total_cost_clp: 0,
			}
			this.costsPayments.forEach(costsPayment => {
				const diff = this.getDifference(costsPayment)
				totals.total_cost_uf += diff.total_cost_uf;
				totals.total_cost_clp += diff.total_cost_clp;
			});
			return totals
		},
		colors(){
			return this.$store.state.costbreakdown.costTableColorMap
		},
		costsPayments(){
			return this.costsTable.payments
		},
		filteredPayments(){
			if(!this.costsPayments || this.costsPayments.length === 0) return [];
			return this.costsPayments.filter(payment => payment.amount);
		},

		ufValues(){
			return this.$store.state.general.posteriorDaysUf
		},
		paymentStatusTableColor() {
			return this.$store.state.costbreakdown.costTableColorMap.paymentStatusTableColor;
		},
		footerPaymentStatusColor() {
			return this.$store.state.costbreakdown.costTableColorMap.footerPaymentStatusColor;
		},
		secondFooterPaymentStatusColor() {
			return this.$store.state.costbreakdown.costTableColorMap.secondFooterPaymentStatusColor;
		},
		colorStatusComprobation(){
			if(this.statusComprobation){
				return this.footerPaymentStatusColor
			} else {
				return '#F44336'
			}
		},
		statusComprobation(){
			return this.totalProjectCostSummaryPayments.total_cost_uf >= this.totalProjectCostSummary.total_cost_uf
		},
		totalMainArqProject(){
			const values = getParentItemTotalValueMultiWithTax([this.costsTable, this.costsTable.surfaces], this.costsTable.tax, this.costsTable.uf_value?.uf_value)
			return values;
		},
		receptionTotalCostSummary() {
			const values = getParentItemTotalValueWithTax(this.costsTable.reception, this.costsTable.tax, this.costsTable.uf_value?.uf_value)
			return values;
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		allCostTables() {
			const tables = new Set();
			tables.add(this.costsTable);
			this.summaryInfo.mainProjects.forEach(mp => tables.add(mp.project_table));
			this.summaryInfo.projects.forEach(p => tables.add(p.project_table));
			this.summaryInfo.stages.forEach(s => tables.add(s.project_table));
			this.summaryInfo.specialties.forEach(sp => tables.add(sp.project_table));
			if (this.summaryInfo.reception) tables.add(this.summaryInfo.reception.project_table);
			return Array.from(tables);
		},
	},
	watch: {
		ufValue: {
			handler() {
				if(this.costsPayments){
					this.costsPayments.forEach(costsPayment => {
						this.setItemClpValueFromUf(costsPayment)
					});
				}
			},
			immediate: true
		},
		costsPayments: {
			handler() {
				if(this.costsPayments){
					this.costsPayments.forEach(costsPayment => {
						this.setItemClpValueFromUf(costsPayment)
					});
				}
			},
			immediate: true
		}
	},
	mounted(){
		if(this.costsTable.payments){
			this.costsTable.payments.forEach(costsPayment => {
				this.setItemClpValueFromUf(costsPayment)
			});
		}
	},
  methods: {
		openCostBreakdownSummary(info){
			this.$store.commit('costbreakdown/setCostBreakdownSummaryTablesModalInfo', info)
			this.$store.commit('costbreakdown/setCostBreakdownSummaryTablesModal', true)
		},
		shouldShowPayment(payment){
			const details = this.getCostsPaymentDetails(payment);
			return details.total?.total_cost_uf_taxed > 0 || details.total?.total_cost_clp_taxed > 0;
		},
		getFilteredPaymentsForStage(costsPayment){
			console.log('getFilteredPaymentsForStage costsPayment', costsPayment)
			if(!costsPayment || !costsPayment.payments || costsPayment.payments.length === 0) return [];
			return costsPayment.payments.filter(payment => {
				const details = this.getCostsPaymentDetails(payment);
				return (details.total?.total_cost_uf_taxed > 0 || details.total?.total_cost_clp_taxed > 0);
			});
		},
		getMainProjectDescription(mainProject){
			return mainProject?.project_cost_info?.title || ''
		},
		getMainProjectTitle(mainProject){
      const parentName = mainProject?.contract?.info?.project_type?.parent?.name || this.project?.info?.project_type?.parent?.name || '';
      const categoryName = mainProject?.contract?.info?.project_type?.category?.name || this.project?.info?.project_type?.category?.name || '';
			const projectTypeName = mainProject?.contract?.info?.project_type?.name
      
      if (parentName && categoryName) {
        return `${categoryName} | ${parentName} | ${projectTypeName}`;
      }
      return parentName || categoryName || '';
		},
		getCostsPaymentDetails(costsPayment){
			const item = findItemInCostsTable(this.costsTable, costsPayment.item_type, costsPayment.type_item_id)
			let costsTable = this.costsTable
			if(costsPayment.item_type !== 'cost_table' && item){
				costsTable = findItemInCostsTable(this.costsTable, 'cost_table', item.cost_project_id)
			}
			else{
				costsTable = item
			}
			let title = ''
			let projectTypeSubtitle = null
			let total = { 
				total_cost_uf: 0,
				tax_value_uf: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp: 0,
				tax_value_clp: 0,
				total_cost_clp_taxed: 0
			}
			let isAddendum = costsTable?.contract?.parent_contract ? true : false

			if(costsPayment.item_type == 'cost_table' && item){
				let items = [];
				if (costsTable.surfaces?.items) {
					items.push(...costsTable.surfaces.items.map(item => ({ ...item, isFromSurface: true })));
				}
				if (costsTable.items) {
					items.push(...costsTable.items);
				}
				title = items.reduce((desc, item) => {
					if (!item.name || item.name.trim() === '') return desc;
					const itemText = item.isFromSurface && item.qty ? `${item.name} ${item.qty}<span style="text-transform: lowercase!important;">m²</span>` : item.name;
					return desc ? `${desc}, ${itemText}` : itemText
				}, '') || ''

				const parentName = this.project?.info?.project_type?.parent?.name || '';
				const categoryName = this.project?.info?.project_type?.category?.name || '';

				if (parentName && categoryName) {
						projectTypeSubtitle = `${categoryName} | ${parentName}`;
				}
				projectTypeSubtitle = parentName || categoryName || null;
				projectTypeSubtitle = projectTypeSubtitle ? projectTypeSubtitle + ' - ' + this.project?.info?.project_type?.name : null;
				title = this.getMainProjectDescription(costsTable);
				projectTypeSubtitle = this.getMainProjectTitle(costsTable);
				total = getParentItemTotalValueMultiWithTax([item, item.surfaces], item.tax, item.uf_value?.uf_value)
			}
			else if(costsPayment.item_type == 'stage' && item){
				title = item.stage?.name
				total = getParentItemTotalValueMultiWithTax([item], costsTable.tax, costsTable.uf_value?.uf_value)
			}
			else if(costsPayment.item_type == 'specialty' && item){
				title = item.specialty?.categoryName
				total = getParentItemTotalValueMultiWithTax([item], costsTable.tax, costsTable.uf_value?.uf_value)
			}
			else if(costsPayment.item_type == 'reception' && item){
				title = 'Recepción ' + (item.reception?.name || '')
				total = getParentItemTotalValueMultiWithTax([item], costsTable.tax, costsTable.uf_value?.uf_value)
			}
			return {
				title: title,
				projectTypeSubtitle,
				total,
				isAddendum
			}
		},
		getTotalSinglePaymentTotalsWithTax(costsPayment) {
			let total = { 
				total_cost_uf: 0,
				tax_value_uf: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp: 0,
				tax_value_clp: 0,
				total_cost_clp_taxed: 0
			};
			this.allCostTables.forEach(costTable => {
				const val = getSinglePaymentTotalsWithTax(costsPayment, costTable);
				total.total_cost_uf += val.total_cost_uf || 0;
				total.tax_value_uf += val.tax_value_uf || 0;
				total.total_cost_uf_taxed += val.total_cost_uf_taxed || 0;
				total.total_cost_clp += val.total_cost_clp || 0;
				total.tax_value_clp += val.tax_value_clp || 0;
				total.total_cost_clp_taxed += val.total_cost_clp_taxed || 0;
				
			});
			return total;
		},
		handleDateChange(date, costsPayment) {
			this.setItemClpValueFromUf(costsPayment)
		},
		getSetUfValue(costsPayment){
			if(!this.ufValues) return
			const found_uf = this.ufValues.find((uf) => {
				return uf.date == costsPayment.pay_date
			})
			if(found_uf){
				costsPayment.uf_value_id = found_uf.id
				costsPayment.uf_value = found_uf
				return {
					status: true,
					text: 'UF: ' + this.$options.filters.toThousandFilter( found_uf.uf_value, 2 )
				}
			}
			// this.setMessage({
			// 	message: 'Aún no hay un valor para la UF en la fecha seleccionada. Se actualizará este valor cuando la CMF lo informe.',
			// 	title: 'UF no informada',
			// 	type: 'danger',
			// 	icon: 'mdi-close-octagon',
			// 	color: '#FF1209',
			// })
			return {
				status: false,
				text: 'UF no informada por sistema público'
			}
		},
		openManualPaymentModal(costsPayment){
			const amountToPay = this.getTotalSinglePaymentTotalsWithTax(costsPayment)
			const orderData = {
				amount: Math.round(amountToPay.total_cost_clp_taxed),
				amount_uf: amountToPay.total_cost_uf_taxed,
				payer_id: this.costsTable.project?.client_id || null,
				concept: 'Pago Cuota Proyecto',
				item_id: costsPayment.id,
				item_type: 'project_payment_et',
				method: 'Transferencia',
				payment_date: new Date().toISOString().split('T')[0],
			}
			this.$store.commit('general/setManualPaymentOrderModal', {
				orderData,
				status: true
			})
		},
		async sendPaymentRequest(costsPayment){
			if(!costsPayment.pay_date){
				this.setMessage({
					message: 'Primero debes seleccionar una fecha para el pago.',
					title: 'Sin fecha para pago',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				})
				return null
			}
			const orderData = {
				amount: Math.round(this.getPaymentToPay(costsPayment, this.costsTable).total_cost_clp_taxed),
				amount_uf: this.getPaymentToPay(costsPayment, this.costsTable).total_cost_uf_taxed,
				payer_id: this.costsTable.project?.client_id || null,
				concept: 'Pago Cuota Proyecto',
				item_id: costsPayment.id,
				item_type: 'project_payment_et'
			}
			const payment_order = await createPaymentOrder(orderData)
			if(payment_order.code == 200){
				const paymentRequest = await sendPaymentRequest({ payment_order_id: payment_order.payment_order.id, project_id: this.costsTable.project?.id })
				if(paymentRequest.code == 200){
					this.setMessage({
						message: 'Solicitud de pago enviada correctamente al correo del cliente.',
						title: 'Éxito',
						type: 'success',
						icon: 'mdi-check-circle-outline',
						color: '#4CAF50',
					})
					return
				}
			}
			this.setMessage({
				message: 'Hubo un error en la operación, por favor intenta nuevamente',
				title: 'Ha ocurrido un error',
				type: 'danger',
				icon: 'mdi-close-octagon',
				color: '#FF1209',
			})
		},
		onKeyPress(event){
			if(event.target?.value > 9999999){
				event.preventDefault();
			}
		},
		validateCLP(e) {
			if (e.key === 'e') {
				e.preventDefault()
			}
			if(e.target?.value > 9999999999){
				e.preventDefault();
			}
		},
		sanitizeUF(costsPayment) {
			let value = String(costsPayment.adjustment_uf ?? '');
			value = value.replace(',', '.');
			const isNegative = value.startsWith('-');
			value = value
				.replace(/[^0-9.]/g, '')
				.replace(/^0+(?=\d)/, '');
			const parts = value.split('.');
			if (parts.length > 2) {
				value = parts[0] + '.' + parts.slice(1).join('');
			}
			if (isNegative && value !== '') {
				value = '-' + value;
			}
			costsPayment.adjustment_uf = value;
			if (value !== '' && !value.endsWith('.')) {
				this.setItemClpValueFromUf(costsPayment);
			}
		},
		sanitizeIntegerInput(costsPayment) {
			let value = costsPayment.adjustment_clp;
			const isNegative = value.startsWith('-');
			value = value.replace(/\D/g, '');
			value = value.replace(/^0+(?!$)/, '');
			if (isNegative && value !== '') {
				value = '-' + value;
			}
			costsPayment.adjustment_clp = value || '0';
			
			this.setItemUfValueFromClp(costsPayment);
		},
		setItemClpValueFromUf(costsPayment){
			const clp_value = costsPayment.adjustment_uf * costsPayment.uf_value?.uf_value
			costsPayment.adjustment_clp = parseFloat(clp_value) || 0
		},
		setItemUfValueFromClp(costsPayment){
			const uf_value = costsPayment.adjustment_clp / costsPayment.uf_value?.uf_value
			costsPayment.adjustment_uf = parseFloat(uf_value) || 0
		},
		calcFontColor(backgroundColor){
			if (!backgroundColor) return '#000';
			let hex = backgroundColor.replace('#', '');
			if (hex.length === 3) {
				hex = hex.split('').map(char => char + char).join('');
			}
			const r = parseInt(hex.substring(0, 2), 16);
			const g = parseInt(hex.substring(2, 4), 16);
			const b = parseInt(hex.substring(4, 6), 16);
			const brightness = (r * 299 + g * 587 + b * 114) / 1000;
			return brightness > 128 ? '#000' : '#fff';
		},
    openColorPicker(key) {
      this.activeColorKey = key
      this.colorPickerVisible = true
    },
		getPaymentTotals(costsPayment) {
			if (!costsPayment || !Array.isArray(costsPayment.payments)) {
				return {
					total_cost_uf: 0,
					total_cost_clp: 0
				};
			}

			let total_uf = 0;
			let total_clp = 0;

			costsPayment.payments.forEach(payment => {
				let amount_uf = 0;
				let amount_clp = 0;

				if (payment.item_type === 'cost_table') {
					amount_uf = this.totalMainArqProject.total_cost_uf * payment.amount / 100;
					amount_clp = this.totalMainArqProject.total_cost_clp * payment.amount / 100;
				}

				if (payment.item_type === 'reception') {
					amount_uf = this.receptionTotalCostSummary.total_cost_uf * payment.amount / 100;
					amount_clp = this.receptionTotalCostSummary.total_cost_clp * payment.amount / 100;
				}

				if (payment.item_type === 'secondary_project') {
					const project = this.costsTable.projects.find(s => s.id === payment.type_item_id);
					const totals = this.getStageValues(project);
					amount_uf = totals.total_cost_uf * payment.amount / 100;
					amount_clp = totals.total_cost_clp * payment.amount / 100;
				}

				if (payment.item_type === 'stage') {
					const stage = this.costsTable.stages.find(s => s.id === payment.type_item_id);
					const totals = this.getStageValues(stage);
					amount_uf = totals.total_cost_uf * payment.amount / 100;
					amount_clp = totals.total_cost_clp * payment.amount / 100;
				}

				if (payment.item_type === 'specialty') {
					const specialty = this.costsTable.specialties.find(s => s.id === payment.type_item_id);
					const totals = this.getStageValues(specialty);
					amount_uf = totals.total_cost_uf * payment.amount / 100;
					amount_clp = totals.total_cost_clp * payment.amount / 100;
				}

				if (!isNaN(amount_uf)) total_uf += amount_uf;
				if (!isNaN(amount_clp)) total_clp += amount_clp;
			});

			return {
				total_cost_uf: total_uf,
				total_cost_clp: total_clp
			};
		},
		totalPaid(costsPayment) {
			if (!costsPayment || !Array.isArray(costsPayment.payments)) {
				return {
					total_cost_uf: 0,
					total_cost_clp: 0
				};
			}

			let total_uf = 0;
			let total_clp = 0;

			costsPayment.payment_order.forEach(payment_order => {
				total_uf += payment_order.amount / this.ufValue || 0;
				total_clp += payment_order.amount || 0;
			});

			return {
				total_cost_uf: total_uf,
				total_cost_clp: total_clp
			};
		},
		getDifference(costsPayment) {
			if (!costsPayment || !Array.isArray(costsPayment.payments)) {
				return {
					total_cost_uf: 0,
					total_cost_clp: 0
				};
			}
			// const to_pay = this.getPaymentToPay(costsPayment, this.costsTable)
			const to_pay = this.getTotalSinglePaymentTotalsWithTax(costsPayment)
			const total_paid = this.totalPaid(costsPayment)

			const uf_diff = to_pay.total_cost_uf_taxed - total_paid.total_cost_uf
			const clp_diff = to_pay.total_cost_clp_taxed - total_paid.total_cost_clp

			return {
				total_cost_uf: uf_diff,
				total_cost_clp: clp_diff
			};
		},
		getStageValues(stage) {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;
			const round2 = (n) => Math.round(n * 100) / 100;

			if (!Array.isArray(stage.items) || stage.items.length === 0) {
				const qty = parse(stage.qty);
				const uf = parse(stage.unit_cost_uf);
				const clp = parse(stage.unit_cost_clp);

				totals.qty = qty;
				totals.unit_cost_uf = uf;
				totals.unit_cost_clp = clp;
				totals.total_cost_uf = qty * uf;
				totals.total_cost_clp = qty * clp;

				return totals;
			}

			for (const item of stage.items) {
				if (Array.isArray(item.subitems) && item.subitems.length > 0) {
					for (const sub of item.subitems) {
						const qty = parse(sub.qty);
						const uf = parse(sub.unit_cost_uf);
						const clp = parse(sub.unit_cost_clp);

						totals.qty += qty;
						totals.unit_cost_uf += uf;
						totals.unit_cost_clp += clp;
						totals.total_cost_uf += uf * qty;
						totals.total_cost_clp += clp * qty;
					}
				} else {
					const qty = parse(item.qty);
					const uf = parse(item.unit_cost_uf);
					const clp = parse(item.unit_cost_clp);

					totals.qty += qty;
					totals.unit_cost_uf += uf;
					totals.unit_cost_clp += clp;
					totals.total_cost_uf += uf * qty;
					totals.total_cost_clp += clp * qty;
				}
			}

			const tax_multiplier = 1 + this.costsTable.tax?.value/100

			return {
				qty: round2(totals.qty * tax_multiplier),
				unit_cost_uf: round2(totals.unit_cost_uf * tax_multiplier),
				unit_cost_clp: round2(totals.unit_cost_clp * tax_multiplier),
				total_cost_uf: round2(totals.total_cost_uf * tax_multiplier),
				total_cost_clp: round2(totals.total_cost_clp * tax_multiplier),
			};
		},
		async startSendTableCostToClient(){
			const singlePaymentTotals = (costsPayment) => this.getSinglePaymentTotalsWithTax(costsPayment, this.costsTable);
			const totalPaymentTotals = (costsPayment) => this.getTotalSinglePaymentTotalsWithTax(costsPayment);
			const formatUF = (value) => this.$options.filters.toThousandFilter(value, 2);
			const formatCLP = (value) => this.$options.filters.toThousandFilter(value);
			
			const main_info = this.costsPayments.map((costsPayment, index) => {
				const single = singlePaymentTotals(costsPayment);
				const total = totalPaymentTotals(costsPayment);
				const paid = this.totalPaid(costsPayment);
				const diff = this.getDifference(costsPayment);
				
				return {
					payment_status: `EP${index+1}`,
					initial_contract_amount: {
						uf: formatUF(single.total_cost_uf_taxed),
						clp: formatCLP(single.total_cost_clp_taxed)
					},
					payment_date: costsPayment.pay_date || null,
					adjustment_amount: {
						uf: formatUF(total.total_cost_uf_taxed - single.total_cost_uf_taxed),
						clp: formatCLP(total.total_cost_clp_taxed - single.total_cost_clp_taxed)
					},
					amount_to_pay: {
						net_amount: {
							uf: formatUF(total.total_cost_uf),
							clp: formatCLP(total.total_cost_clp)
						},
						tax_amount: {
							uf: formatUF(total.tax_value_uf),
							clp: formatCLP(total.tax_value_clp)
						},
						total_amount: {
							uf: formatUF(total.total_cost_uf_taxed),
							clp: formatCLP(total.total_cost_clp_taxed)
						}
					},
					total_client_payments: {
						uf: formatUF(paid.total_cost_uf),
						clp: formatCLP(paid.total_cost_clp)
					},
					client_balance: {
						uf: formatUF(diff.total_cost_uf),
						clp: formatCLP(diff.total_cost_clp)
					},
					observation: '--'
				};
			});
			const first_footer = {
				payment_status: 'Total Estados de Pago',
				initial_contract_amount: {
					uf: formatUF(this.getAllPaymentsTotalsWithTax(this.costsPayments, this.costsTable).total_cost_uf_taxed),
					clp: formatCLP(this.getAllPaymentsTotalsWithTax(this.costsPayments, this.costsTable).total_cost_clp_taxed)
				},
				payment_date: null,
				adjustment_amount: {
					uf: formatUF(this.totalAddendumCostPayments.total_cost_uf_taxed),
					clp: formatCLP(this.totalAddendumCostPayments.total_cost_clp_taxed)
				},
				amount_to_pay: {
					net_amount: {
						uf: formatUF(this.totalProjectCostSummaryPayments.total_cost_uf),
						clp: formatCLP(this.totalProjectCostSummaryPayments.total_cost_clp)
					},
					tax_amount: {
						uf: formatUF(this.totalProjectCostSummaryPayments.tax_value_uf),
						clp: formatCLP(this.totalProjectCostSummaryPayments.tax_value_clp)
					},
					total_amount: {
						uf: formatUF(this.totalProjectCostSummaryPayments.total_cost_uf_taxed),
						clp: formatCLP(this.totalProjectCostSummaryPayments.total_cost_clp_taxed)
					}
				},
				total_client_payments: {
					uf: formatUF(this.totalPaidTotals.total_cost_uf),
					clp: formatCLP(this.totalPaidTotals.total_cost_clp)
				},
				client_balance: {
					uf: formatUF(this.totalDifference.total_cost_uf),
					clp: formatCLP(this.totalDifference.total_cost_clp)
				},
				observation: '--'
			};
			const second_footer = {
				payment_status: 'Total Contrato (Comprobación)',
				initial_contract_amount: {
					uf: formatUF(this.totalMainProjectCost.total_cost_uf_taxed),
					clp: formatCLP(this.totalMainProjectCost.total_cost_clp_taxed)
				},
				payment_date: null,
				adjustment_amount: {
					uf: formatUF(this.totalAddendumCost.total_cost_uf_taxed),
					clp: formatCLP(this.totalAddendumCost.total_cost_clp_taxed)
				},
				amount_to_pay: {
					net_amount: {
						uf: formatUF(this.totalProjectCostSummary.total_cost_uf),
						clp: formatCLP(this.totalProjectCostSummary.total_cost_clp)
					},
					tax_amount: {
						uf: formatUF(this.totalProjectCostSummary.tax_value_uf),
						clp: formatCLP(this.totalProjectCostSummary.tax_value_clp)
					},
					total_amount: {
						uf: formatUF(this.totalProjectCostSummary.total_cost_uf_taxed),
						clp: formatCLP(this.totalProjectCostSummary.total_cost_clp_taxed)
					}
				},
				total_client_payments: null,
				client_balance: null,
				observation: null
			};

			const data = {
				project_id: this.costsTable.project_id,
				table_cost_info: {
					main_info,
					first_footer,
					second_footer
				}
			}
			// Abrir el modal para mostrar el PDF y permitir enviar
			this.$store.commit('costbreakdown/setCostPdfModal', {
				type: 'cost_totals',
				requestData: data
			})
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  },
};
</script>

<style scoped>
	.costbreakdown-detail-table{
		table-layout: fixed;
		width: 100%;
	}
	tr.no-hover-cells,
	tr.no-hover-cells td {
		background-color: inherit !important;
	}
	.action-container{
		width: 60px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.custom-table-cost table .main-row{
		border-top: 2px solid #bcbcbc;
		border-bottom: 2px solid #bcbcbc;
	}
	.custom-table-cost table .header-rows-custom{
		/* background: rgb(120, 120, 120); */
		color: white;
		font-size: 10px;
		font-weight: bold;
	}
	.custom-table-cost table tbody tr.header-rows-custom td,
	.custom-table-cost table thead tr.header-rows-custom td{
		height: 25px;
	}
	.custom-table-cost table .header-rows-custom:hover{
		/* background: rgb(103, 103, 103) !important; */
	}
	.custom-table-cost table .header-rows-custom.indigo:hover{
		background: #3f51b5 !important;
	}
	.custom-table-cost table .header-rows-custom.green:hover{
		background: #409242 !important;
	}
	.custom-table-cost table .header-rows-custom.blue:hover{
		background: #2196F3 !important;
	}
	/deep/.costbreakdown-detail-table,
	/deep/.costbreakdown-detail-table td{
		vertical-align: top;
	}
	/deep/.costbreakdown-detail-table:hover {
		background-color: rgb(235, 235, 235);
	}
</style>
<style>
	.custom-table-cost table {
		border-collapse: collapse;
	}
	.custom-table-cost table td{
		border: 1px solid #ccc;
	}
	.custom-tooltip-payment-status{
		background-color: white;
		max-width: 350px;
		padding: 10px;
		border: 1px solid grey;
		opacity: 1!important;
	}
	.custom-tooltip-payment-status-details{
		background-color: white;
		max-width: 450px;
		min-width: 350px;
		padding: 10px;
		border: 1px solid grey;
		opacity: 1!important;
	}
	.payments-subdetails-box{
		border: 1px solid #ccc;
		border-radius: 0 0 5px 5px;
		padding: 10px;
	}
</style>